import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { IconContext } from 'react-icons';

const useStyles = makeStyles(theme => ({
    button:{
        "&.clear": {
            width: '100%',
            backgroundColor: theme.palette.background.white,
            color: theme.palette.scaiPro.primary,
            border:`solid thin ${theme.palette.scaiPro.primary}`, 
            textTransform: 'capitalize',
            fontSize: '1.4rem',
            fontWeight:300,
            '&:hover': {
                backgroundColor: '#F1F7FC',
            },
        },
        "&.ctmMenu": {
            width: '100%',
            backgroundColor: theme.palette.background.white,
            color: theme.palette.scaiPro.primary,
            border:`solid thin ${theme.palette.scaiPro.primary}`, 
            textTransform: 'capitalize',
            fontSize: '1.6rem',
            fontWeight:300,
            margin:"6px",
            zIndex:'2',
            '&:hover': {
                backgroundColor: '#F1F7FC',
            },
            "@media (min-height: 1081px)":{
                margin: '10px',
            }
        },
        "&.ctmMenuHidden": {
            width: '100%',
            backgroundColor: theme.palette.background.white,
            color: "#bfbfbf",
            border:`solid thin #bfbfbf`, 
            textTransform: 'capitalize',
            fontSize: '1.6rem',
            fontWeight:300,
            margin:"6px",
            '&:hover': {
                backgroundColor: '#F1F7FC',
            },
            "@media (min-height: 1081px)":{
                margin: '10px',
            }
        },

        "&.btnUpdate":{
            backgroundColor: '#6AA2AA',
            color: theme.palette.background.white,
            width: '100%',
            fontSize: '1.4rem',
            textTransform: 'capitalize',
            fontWeight: 'normal',
        },
        "&.btnDelete":{
            border: 'solid thin #B62424',
            color: '#FFFFFF',
            backgroundColor:'#B62424',
            width: '100%',
            fontSize: '1.4rem',
            textTransform: 'capitalize',
            fontWeight: 'normal',
            '&:hover': {
                backgroundColor: '#8A1B1B',
            },
        },
        "&.btnSubmit":{
            backgroundColor: '#3F783F',
            color: theme.palette.background.white,
            width: '100%',
            fontSize: '1.4rem',
            textTransform: 'capitalize',
            fontWeight: 'normal',
        },
        "&.btnCancel":{
            border: 'solid thin #B62424',
            color: '#B62424',
            width: '100%',
            fontSize: '1.4rem',
            textTransform: 'capitalize',
            fontWeight: 'normal',
        }
    },
    icon: {
        marginRight: theme.spacing(1),
        "&.tfsHidden":{
            background: '#bfbfbf',
            borderRadius: '50%',
            color: '#bfbfbf',
        },
        "&.tfs":{
            background: 'red',
            borderRadius: '50%',
            color: 'red',
        },
        "&.trvHidden":{
            background: '#bfbfbf',
            borderRadius: '50%',
            color: '#bfbfbf',
        },
        "&.trv":{
            background: 'red',
            borderRadius: '50%',
            color: 'red',
        },
        "&.aMeasurementHidden":{
            background: '#bfbfbf',
            borderRadius: '50%',
            color: '#bfbfbf',
        },
        "&.aMeasurement":{
            background: '#6fda59',
            borderRadius: '50%',
            color: '#6fda59',
        },
        "&.tftHidden":{
            background: '#bfbfbf',
            borderRadius: '50%',
            color: '#bfbfbf',
        },
        "&.tft":{
            background: '#6667ab',
            borderRadius: '50%',
            color: '#6667ab',
        }
    },
}))

function CustomButton(props) {
    const { name, onClick, i18n, icon, iconClassName, isDisabled } = props;
    const classes = useStyles();
    const { t } = useTranslation(i18n);
    console.log('name:', t(name))

    return (
      <Button disabled={isDisabled} className={`${classes.button} ${props.className}`} onClick={onClick}>
        {icon && (
            <IconContext.Provider value={{ className: `${classes.icon} ${iconClassName}` }}>
                {icon}
            </IconContext.Provider>
        )}
        {t(name)}
      </Button>
    );

}
  
export default CustomButton;